import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill'
import '@fontsource/noto-sans/400.css'
import '@fontsource/noto-sans/500.css'
import '@fontsource/noto-sans/600.css'
import '@fontsource/noto-sans/700.css'

// Self-hosted to keep CSP `font-src 'self'` strict (no external CDN).
polyfillCountryFlagEmojis('Twemoji Country Flags', '/TwemojiCountryFlags.woff2')
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/600.css'
import '@fontsource/roboto-mono/400.css'
import './styles/design-tokens.css'
import './index.css'
import App from './App.tsx'
import theme from './theme'
import { registerSW } from 'virtual:pwa-register'

// Register service worker with auto-update
registerSW({
  onNeedRefresh() {
    // Service worker has been updated and waiting to activate
    console.log('[PWA] New content available, will refresh automatically')
  },
  onOfflineReady() {
    // App is ready to work offline
    console.log('[PWA] App ready to work offline')
  },
  onRegistered(registration) {
    // Service worker registered successfully
    console.log('[PWA] Service worker registered', registration)

    // Check for updates every hour
    if (registration) {
      setInterval(() => {
        registration.update()
      }, 60 * 60 * 1000) // 1 hour
    }
  },
  onRegisterError(error) {
    console.error('[PWA] Service worker registration failed', error)
  },
  immediate: true
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>,
)
